<template>
  <section class="content-wrapper__container" v-if="options['Discover machines']">
      <div style="overflow: hidden;">
          <div class="content-wrapper" v-for="item in options['Discover machines']['Discover machines']" :class="{ 'image-left': content.imagePosition === 'left', 'image-right': content.imagePosition === 'right' }">
              <div class="text-content">
              <h2>{{ item.title }}</h2>
              <p>{{ item.text }}</p>
              <a :href="item.link" class="arrow__link">
                  <svg class="arrow arrow--white" width="30.000000" height="20.000000" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs/>
                      <path id="Union" d="M25.48 8.85L18.05 1.62L19.72 0L29.16 9.18L30 10L29.16 10.81L19.72 20L18.05 18.37L25.48 11.14L0 11.14L0 8.85L25.48 8.85Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="evenodd"/>
                  </svg>
                  <svg class="arrow arrow--black" width="30.000000" height="20.000000" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs/>
                      <path id="Union" d="M25.48 8.85L18.05 1.62L19.72 0L29.16 9.18L30 10L29.16 10.81L19.72 20L18.05 18.37L25.48 11.14L0 11.14L0 8.85L25.48 8.85Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
                  </svg>
              </a>
              </div>
              <div class="image-content">
                <img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="Изображение">
              </div>
          </div>
      </div>
  </section>
</template>

<script>
export default {
  props: {
    content: [Array,Object],
  },
  computed: {
    options() {
            return this.$store.state.options;
        },
    }
};
</script>

<style scoped>

.content-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: linear-gradient(180.00deg, rgb(173, 184, 199),rgb(222, 230, 234) 100%);
  padding: 74px 64px;
  width: 100%;
  margin-top: 242px;

}

.text-content {
  width: 58%;
  z-index: 2;
  max-width: 806px;
}

.text-content h2 {
  color: rgb(5, 5, 5);
  font-size: 44px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  padding-bottom: 24px;
}

.text-content p {
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0%;
  max-width: 448px;
}
  .arrow__link {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 92px;
  height: 92px;
  position: absolute;
  right: 64px;
  bottom: 24px;
  border-radius: 50%;
  background-color: black;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s ease;
}

.arrow__link .arrow {
  position: absolute;
  transition: all 0.5s ease;
}

.arrow__link .arrow--white {
  opacity: 1;
  transform: translateX(0%); /* Белая стрелка по центру */
}

.arrow__link .arrow--black {
  opacity: 1;
  transform: translateX(-300%); /* Черная стрелка по центру */
}
.arrow__link:hover{
  background-color: rgb(255, 183, 16);
}
.arrow__link:hover .arrow--white {
  opacity: 1;
  transform: translateX(300%); /* Белая стрелка уходит вправо */
}

.arrow__link:hover .arrow--black {
  opacity: 1;
  transform: translateX(0%); /* Черная стрелка заходит в центр */
}
/* .text-content a{
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3222px;
  background: rgb(5, 5, 5);
  width: 92px;
  height: 92px;
  position: absolute;
  right: 64px;
  bottom: 24px;
} */
.action-button {
  padding: 12px 32px;
  font-size: 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.action-button:hover {
  background-color: #0056b3;
}

.image-content {
  position: absolute;
  max-height: 513px;
  width: auto;
  bottom: 0;
  z-index: 1;
}

.image-content img {
  height: 100%;
  max-height: 513px;
  width: auto;
}

/* Расположение изображения слева, текст справа */
.image-left .text-content {
  margin-left: auto;
}

.image-left .image-content {
  left: -170px;
}

/* Расположение изображения справа, текст слева */
.image-right .text-content {
  margin-right: auto;
}

.image-right .image-content {
  right: 0;
}
@media (max-width: 1400px) {
  .image-content img{
    width: 90%;
  }
}
@media (max-width: 1300px) {
  .image-content img{
    width: 80%;
  }
  .content-wrapper {
    padding: 40px 20px;
  }
  .arrow__link{
    right: 20px;
  }
}
@media (max-width: 1024px) {
.content-wrapper {
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 20px;
  margin-top: unset;
}
.image-left .text-content{
  margin-left: unset;
}
.text-content {
  width: 100%;
  max-width: 80%;
  padding-bottom: 32px;

}
.text-content h2{
  font-size: 32px;
}
.image-content {
  position: static;
  width: 100%;
  max-height: none;
  text-align: center;
}

.image-content img {
  width: 75%;
  height: auto;
  object-fit: cover;
}

.text-content a {
  bottom: unset;
  top: 40px;
  right: 20px;
}
}
@media (max-width: 768px) {
.image-content img{
  width: 90%;
}
.text-content h2{
  font-size: 22px;
}
.text-content p{
  font-size: 18px;
}
.arrow__link{
  width: 56px;
  height: 56px;
}
.content-wrapper{
  margin-top: unset;
}
}
</style>
